/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlaceDto } from '../../models/place-dto';

export interface PlaceControllerFindAllV1$Params {

/**
 * 장소 타입 필터
 */
  type?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function placeControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PlaceControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlaceDto>>> {
  const rb = new RequestBuilder(rootUrl, placeControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlaceDto>>;
    })
  );
}

placeControllerFindAllV1.PATH = '/api/v1/places';
